import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './publicSite.css';

/**
 * 法律文件頁的共用外框(服務條款 / 免責聲明)—— R316
 * -----------------------------------------------------------------------------
 * 版面照文案稿 artifact 逐塊搬:頂欄(品牌 + 頁名)→ `<main class="doc">` → 頁尾。
 *
 * ⚠️ **`scope` 一定要傳對**:樣式是**每頁各自命名空間**(`publicSite.css` 檔頭寫明
 * 為什麼不能合成一個)—— 傳錯 scope 不會報錯,只會整頁沒有樣式。
 *
 * ⚠️ **語言選單刻意不畫**(owner 2026-09-11:「前端那邊選語言先關掉就好」)。
 * `site.json` 的 ja / en 是**未審校初稿**,法律文件在有人逐條看過之前不可以讓使用者
 * 切過去 —— 藏起來是「沒有的東西不假裝有」,不是漏做。原稿那顆 `<details class="lang-dd">`
 * 本來也是 `href="#"` 的假選單。
 */
export function PublicDocLayout({
  scope,
  pageLabel,
  title,
  updatedDate,
  footerSecondary,
  children,
}: {
  /** `hai-site--terms` | `hai-site--disclaimer` */
  scope: string;
  /** 頂欄右側的頁名 */
  pageLabel: string;
  title: string;
  updatedDate: string;
  /** 頁尾第二條連結(條款頁指向免責聲明,反之亦然) */
  footerSecondary: { to: string; label: string };
  children: ReactNode;
}) {
  const { t } = useTranslation('site');
  return (
    <div className={`hai-site ${scope}`}>
      <div className="bar">
        <div className="bar-in">
          <span className="brand">
            <span className="mark">H</span>
            <span>
              H<span className="ai">Ai</span>&nbsp;Creative
            </span>
          </span>
          <span className="page">{pageLabel}</span>
        </div>
      </div>

      <main className="doc">
        <div className="doc-head">
          <h1>{title}</h1>
          <div className="doc-meta">
            {t('terms.updatedLabel')}
            <b>{updatedDate}</b>
          </div>
        </div>
        {children}
      </main>

      <footer>
        <div className="foot-in">
          <span>{t('docFooter.copyright')}</span>
          <span>
            <Link to="/">{t('docFooter.backHome')}</Link>
            &nbsp;&nbsp;·&nbsp;&nbsp;
            <Link to={footerSecondary.to}>{footerSecondary.label}</Link>
          </span>
        </div>
      </footer>
    </div>
  );
}
